<template>
  <MasterLayout>
    <div class="section__row mt-3">
      <div>
        <b-modal
          ref="my-modal"
          id="modal1"
          hide-footer
          :title="$t('text.fundWallet.confirmingPayment')"
          v-if="status == loading"
        >
          <div
            class="epump-loader"
            style="top: 22%; left: 35%; width: 120px; height: 120px"
          >
            <img src="@/assets/img/epump-logo.png" class="epump-loader-logo" />
          </div>
        </b-modal>
        <b-modal
          v-if="status == success"
          ref="my-modal"
          id="modal1"
          hide-footer
          :title="$t('text.fundWallet.paymentConfirmed')"
        >
          <div style="margin: 0 auto; width: 43%; margin-top: 80px" class>
            <div class="success-checkmark">
              <div class="check-icon">
                <span class="icon-line line-tip"></span>
                <span class="icon-line line-long"></span>
                <div class="icon-circle"></div>
                <div class="icon-fix"></div>
              </div>
            </div>
          </div>
        </b-modal>
        <b-modal
          v-if="status == failure"
          ref="my-modal"
          id="modal1"
          hide-footer
          :title="$t('text.fundWallet.errorConfirming')"
        >
          <div style="margin: 0 auto; width: 43%">
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 130.2 130.2"
              class="cancel_img"
            >
              <circle
                class="path circle"
                fill="none"
                stroke="#D06079"
                stroke-width="6"
                stroke-miterlimit="10"
                cx="65.1"
                cy="65.1"
                r="62.1"
              />
              <line
                class="path line"
                fill="none"
                stroke="#D06079"
                stroke-width="6"
                stroke-linecap="round"
                stroke-miterlimit="10"
                x1="34.4"
                y1="37.9"
                x2="95.8"
                y2="92.3"
              />
              <line
                class="path line"
                fill="none"
                stroke="#D06079"
                stroke-width="6"
                stroke-linecap="round"
                stroke-miterlimit="10"
                x1="95.8"
                y1="38"
                x2="34.4"
                y2="92.2"
              />
            </svg>
          </div>
        </b-modal>
      </div>
      <div class="text-center page-header-heading pt-5 pb-4">
        <p class="page-header">{{ $t("text.extendedReport.fundWallet") }}</p>
      </div>
      <div class="center-card position-relative">
        <div class="top-header"></div>
        <div class="pad-div">
          <ul class="tabs__lists">
            <li class="mt-3 position-relative" @click="changeTab('bank')">
              <a
                href="#"
                class="tab-link"
                :class="[tab === 'bank' ? 'active-tab' : null]"
              >
                <img
                  :src="
                    tab === 'bank'
                      ? require('@/assets/img/bank-active.svg')
                      : require('@/assets/img/bank-disabled.svg')
                  "
                  width="20px"
                  class="mr-2"
                />
                {{ $t("text.extendedReport.bankTransfer") }}
              </a>
              <div class="active-bottom--line" v-if="tab === 'bank'"></div>
              <div class="active-bottom-pointer" v-if="tab === 'bank'"></div>
            </li>
            <li class="mt-3 position-relative" @click="changeTab('card')">
              <a
                href="#"
                class="tab-link"
                :class="[tab === 'card' ? 'active-tab' : null]"
              >
                <img
                  :src="
                    tab === 'card'
                      ? require('@/assets/img/card-active.svg')
                      : require('@/assets/img/credit-cards-payment.svg')
                  "
                  width="20px"
                  class="mr-2"
                />
                {{ $t("text.extendedReport.creditCard") }}
              </a>
              <div class="active-bottom--line" v-if="tab === 'card'"></div>
              <div class="active-bottom-pointer" v-if="tab === 'card'"></div>
            </li>
            <li
              class="mt-3 position-relative"
              @click="changeTab('bankDeposit')"
            >
              <a
                href="#"
                class="tab-link"
                :class="[tab === 'bankDeposit' ? 'active-tab' : null]"
              >
                <img
                  :src="
                    tab === 'bankDeposit'
                      ? require('@/assets/img/cheque-active.svg')
                      : require('@/assets/img/cheque-disabled.svg')
                  "
                  width="20px"
                  class="mr-2"
                />
                {{ $t("text.extendedReport.bankDeposit") }}
              </a>
              <div
                class="active-bottom--line"
                v-if="tab === 'bankDeposit'"
              ></div>
              <div
                class="active-bottom-pointer"
                v-if="tab === 'bankDeposit'"
              ></div>
            </li>
          </ul>
        </div>
      </div>

      <div class="center-card--body pb-3">
        <div v-if="tab === 'card'">
          <div class="mt-3 center-card--header text-center py-3">
            {{ $t("text.fundWallet.fundAccountWithCard") }}
          </div>
          <div class="text-center mt-4">
            <img src="@/assets/img/credit-card.svg" width="35px" />
          </div>
          <div class="text-center mt-4">
            <small class="small_text">{{
              $t("text.fundWallet.howMuch")
            }}</small>
          </div>
          <div class="input_holder">
            <div class="mt-4">
              <input type="hidden" class="email" />
              <input type="hidden" class="phone" />
              <input type="hidden" class="publicKey" />
              <input type="hidden" name="trxRef" class="trxRef" />
              <input type="hidden" name="flwRef" class="flwRef" />
              <input
                type="number"
                name="amount"
                class="form-control form__input amount"
                :placeholder="$t('text.fundWallet.amount')"
                style="width: 100%"
              />
            </div>
          </div>
          <div class="mt-4 text-center">
            <button class="ep-btn ep-primary" @click="makePayment">
              {{ $t("text.fundWallet.payNow") }}
            </button>
          </div>
        </div>

        <div v-if="tab === 'bank'">
          <div class="mt-3 center-card--header text-center py-3">
            {{ $t("text.fundWallet.fundAccountWithBank") }}
          </div>
          <div class="text-center mt-4">
            <img src="@/assets/img/credit_card__grey.svg" width="35px" />
          </div>
          <div class="fund_wallet_user_details_wrapper">
            <div class="mt-4">
              <div
                class="clearfix clearfix_mobile mt-3"
                style="width: 70%; margin: 0 auto"
              >
                <div class="left_div">
                  <span class="accont_text_span"
                    >{{ $t("text.fundWallet.accountName") }}:</span
                  >
                </div>
                <div class="right_div">
                  <b class="accont_text_span" v-if="!showLoader">{{
                    accountName
                  }}</b>
                  <pulse-loader size="15px" v-if="showLoader"></pulse-loader>
                </div>
              </div>
            </div>
            <div
              class="clearfix clearfix_mobile mt-3"
              style="width: 70%; margin: 0 auto"
            >
              <div class="left_div">
                <span class="mr-4 accont_text_span"
                  >{{ $t("text.fundWallet.bankName") }}:</span
                >
              </div>
              <div class="right_div">
                <b class="accont_text_span" v-if="!showLoader">{{
                  bankName
                }}</b>
                <pulse-loader size="15px" v-if="showLoader"></pulse-loader>
              </div>
            </div>
            <div
              class="clearfix clearfix_mobile mt-3"
              style="width: 70%; margin: 0 auto"
            >
              <div class="left_div">
                <span class="mr-4 accont_text_span"
                  >{{ $t("text.fundWallet.accountNumber") }}:</span
                >
              </div>
              <div class="right_div">
                <b class="accont_text_span text-right" v-if="!showLoader">{{
                  reservedAccount
                }}</b>
                <pulse-loader size="15px" v-if="showLoader"></pulse-loader>
              </div>
            </div>
            <div class="mt-5">
              <div class="mt-3 center-card--header text-center">
                {{ $t("text.extendedReport.funding") }}
              </div>
            </div>
          </div>
        </div>

        <div class="" v-if="tab === 'bankDeposit'">
          <div class="row mt-3 py-3 bank-deposit-card--row">
            <div class="col-md-2 text-right">
              <div class="center-card-left--icon">
                <img
                  :src="require('@/assets/img/cheque-active.svg')"
                  width="25px"
                />
              </div>
            </div>
            <div class="col-md-10">
              <div class="center-card--header py-3">
                {{ $t("text.extendedReport.form") }}
              </div>
              <div class="row mt-3">
                <div class="col-md-6">
                  <label>Account</label>
                  <select type="text" placeholder="" v-model="bankNamez">
                    <option
                      :value="bank.bankName"
                      v-for="(bank, i) in banks"
                      :key="i"
                    >
                      {{ bank.accountName }} ({{ bank.accountNumber }})
                    </option>
                  </select>
                </div>
                <div class="col-md-6">
                  <label>{{ $t("text.extendedReport.bank") }} </label>
                  <input
                    type="text"
                    placeholder=""
                    v-model="bankNamez"
                    disabled
                  />
                </div>
              </div>
              <div class="row mt-4">
                <div class="col-md-6">
                  <label>{{ $t("text.extendedReport.name") }}</label>
                  <input type="text" placeholder="" v-model="depositorName" />
                </div>
                <div class="col-md-6">
                  <label>{{ $t("text.extendedReport.slipNumber") }}</label>
                  <input type="text" placeholder="" v-model="depositSlipNo" />
                </div>
              </div>
              <div class="row mt-4">
                <div class="col-md-6">
                  <label>{{ $t("text.extendedReport.amount") }}</label>
                  <input type="text" placeholder="" v-model="amountPaid" />
                </div>
                <div class="col-md-6">
                  <label>{{ $t("text.extendedReport.datepaid") }}</label>
                  <vue-ctk-date-time-picker
                    :max-date="maxDate"
                    v-model="datePaid"
                    :onlyDate="true"
                    :autoClose="true"
                    :locale="this.$root.$i18n.locale"
                    :color="$store.getters.getDatePickerColor"
                    format="YYYY-MM-DDTHH:mm:ss"
                    formatted="DD/MM/YYYY"
                    :label="$t('text.sendReport.selDatePaid')"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="text-center mt-4">
            <button
              class="ep-btn ep-primary"
              @click="payViaBankDeposit"
              :disabled="isButtonDisabled ? true : false"
              style="border: 0"
              :style="[
                isButtonDisabled
                  ? { cursor: 'not-allowed' }
                  : { cursor: 'pointer' },
              ]"
            >
              {{ $t("text.extendedReport.request") }}

              <img
                src="@/assets/img/git_loader.gif"
                style="display: none"
                width="20px"
                class="ml-3 loader2"
              />
            </button>
          </div>
        </div>
      </div>
    </div>
  </MasterLayout>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Customer/MasterLayout.vue";
import configObject from "@/config";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import backgroundUrl from "@/assets/img/MobileWallet.png";
import TableLoader from "@/components/tableLoader/index";
import backImg from "@/assets/img/pattern_img.png";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
import Input from "../../../components/Input.vue";
let $ = JQuery;

export default {
  title: "Fund Wallet:: Epump Portal",
  props: ["corpId"],
  name: "VerifyReceipt",
  components: {
    MasterLayout,
    TableLoader,
    PulseLoader,
    Input,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      backImg,
      tab: "bank",
      loading: 0,
      paymentConfirmed: null,
      success: 1,
      failure: 2,
      status: 0,
      backgroundUrl,
      modalWidth: null,
      modalheight: null,
      showBanner: true,
      payOnline: true,
      email: "",
      phone: "",
      publicKey: "",
      banks: null,
      amount: null,
      depositNo: null,
      depositorName: null,
      bank: null,
      showdropDown: false,
      accountNumber: null,
      toggleBanksDropdown: false,
      isButtonDisabled: false,
      showButtonLoader: true,
      flwRef: "",
      trxRef: "",
      reservedAccount: null,
      accountName: null,
      bankName: null,
      showLoader: false,

      amountPaid: 0,
      depositorName: "",
      bankNamez: null,
      referralCode: "",
      depositSlipNo: "",
      datePaid: this.$moment().format("YYYY-MM-DDTHH:mm:ss"),
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
    };
  },
  created() {
    this.getFundProperties();
    this.getAccountDetails();
  },
  beforeDestroy() {},
  mounted() {},
  methods: {
    changeTab(tab) {
      this.tab = tab;
    },
    randomString(length, chars) {
      var result = "";
      for (var i = length; i > 0; --i)
        result += chars[Math.floor(Math.random() * chars.length)];
      return result;
    },
    getFundProperties() {
      this.showLoader = true;
      if (localStorage.getItem("userDetails")) {
        let url;
        if (this.$route.query.id) {
          url = `${configObject.apiBaseUrl}/Wallet/FundProperties?id=${this.$route.query.id}`;
        } else {
          url = `${configObject.apiBaseUrl}/Wallet/FundProperties`;
        }
        this.axios
          .get(url, configObject.authConfig())
          .then((response) => {
            // if (Object.keys(response.data.dynamicAcct).length) {
            //   this.reservedAccount = response.data.dynamicAcct.accountNumber;
            // }
            let user = JSON.parse(localStorage.getItem("userDetails"));
            this.showLoader = false;
            this.email = user.email;
            this.phone = user.phone;
            this.publicKey = response.data.publicKey;
            this.banks = response.data.banks;
            this.bankNamez = response.data.banks
              ? response.data.banks[0].bankName
              : "";
            this.referralCode = response.data.referralCode;
          })
          .catch((error) => {
            this.showLoader = false;
          });
      }
    },
    getAccountDetails() {
      this.showBtnLoader = true;
      if (localStorage.getItem("userDetails")) {
        let url;
        if (this.$route.query.id) {
          url = `${configObject.apiBaseUrl}/Wallet/Balance?id=${this.$route.query.id}`;
        } else {
          url = `${configObject.apiBaseUrl}/Wallet/Balance`;
        }
        this.axios
          .get(url, configObject.authConfig())
          .then((response) => {
            this.accountName = response.data.accountName;
            this.bankName = response.data.bankName;
          })
          .catch((error) => {
            if (error.message && error.message === "Network Error") {
              this.$toast.open({
                message: "Network Error, Please Check Your Internet Connection",
                type: "error",
                duration: 5000,
              });
            } else {
              this.$toast.open({
                message: "An Error Occured",
                type: "error",
                duration: 5000,
              });
            }
          });
      }
    },
    showModal() {
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    },
    confirmPayment() {
      let data = {
        amount: this.amount.toString() + "",
        trxRef: this.trxRef,
        flwRef: this.flwRef,
        flw: true,
        corpId: this.$route.query.id,
        remis: true,
      };
      this.status = this.loading;
      this.showModal();
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Wallet/FundWalletOnline`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          this.status = this.success;
          this.$toast.open({
            message: this.$t("text.fundWallet.paymentConfirmed"),
            type: "success",
            duration: 12000,
          });
          setTimeout(() => {
            this.$router.push({
              name: "fuelbalance",
              query: { id: this.$route.query.id },
            });
          }, 3000);
        })
        .catch((error) => {});
    },
    payViaBankDeposit(e) {
      e.preventDefault();
      if (!this.depositorName) {
        this.$toast.open({
          message: "Depositior's name is required",
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.depositSlipNo) {
        this.$toast.open({
          message: "Deposit slip number is required",
          type: "error",
          duration: 3000,
        });
        return;
      }

      if (!this.amountPaid) {
        this.$toast.open({
          message: "Amoun paid is required",
          type: "error",
          duration: 3000,
        });
        return;
      }

      let data = {
        bankName: this.bankNamez,
        amountPaid: parseFloat(this.amountPaid),
        depositorName: this.depositorName,
        depositSlipNo: this.depositSlipNo,
        datePaid: this.datePaid,
        referralCode: this.referralCode,
        corpId: this.$route.query.id,
      };

      this.isButtonDisabled = true;
      $(".loader2").show();
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Wallet/RequestToFund`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          this.isButtonDisabled = false;
          $(".loader2").hide();
          this.$toast.open({
            message: "Funds requested successfully",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          this.isButtonDisabled = false;
          $(".loader2").hide();
        });
    },
    makePayment() {
      this.$launchFlutterwave({
        tx_ref: Date.now(),
        amount: parseFloat($(".amount").val()),
        currency: "NGN",
        payment_options: "card",
        customer: {
          email: this.email,
          phone_number: this.phone,
          name: "",
        },
        callback: (data) => {
          this.trxRef = data.tx_ref;
          this.flwRef = data.flw_ref;
          this.amount = data.amount;
        },
        customizations: {
          title: "Epump portal",
          description: "Fund wallet",
          logo: "https://app.epump.com.ng/Content_v3/Images/e-pump%20logo2.png",
        },
        onclose: () => {
          console.log("MODAL CLOSED");
          this.confirmPayment();
        },
      });
    },
    getBankName(bank) {
      this.bank = bank;
      let _this = this;
      this.banks.forEach((bank) => {
        if (bank.bankName === _this.bank) {
          _this.accountName = bank.accountName;
          _this.accountNumber = bank.accountNumber;
        }
      });
    },
  },
};
</script>
